<template>
    <div >
        <el-row :gutter="5">
            <el-col :span="3"><el-input v-model="sName" style="width:100%" placeholder="产品名称"></el-input></el-col>
            <el-col :span="3"><el-input v-model="sCode" style="width:100%" placeholder="商品条码"></el-input></el-col>
            <el-col :span="2"><el-button type="primary" icon="el-icon-search" style="width:100%"  @click="handleRefresh" >查询</el-button></el-col>
            <el-col :span="2"><el-button type="primary" icon="el-icon-plus" style="width:100%" @click="handleAdd">新增</el-button></el-col>
        </el-row>
        <el-table :data="Productions" 
            max-height="600" 
            v-loading="listLoading" 
            ref="singleTable" 
            border 
            header-cell-style="background-color: #f2f2f2;color:#707070;font-weight: normal; background-image: linear-gradient(to bottom,#f8f8f8 0,#ececec 100%);
    background-repeat: repeat-x;"
            @sort-change="changeTableSort"  >
             <el-table-column label="删除" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column label="编辑" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column prop="Name" label="产品名称" sortable='custom'  width="120"></el-table-column>
            <el-table-column prop="Code" label="商品条码" sortable='custom'  width="120"></el-table-column>
            <el-table-column prop="Weight" label="重量(单个)"  width="120" align="right"></el-table-column>
            <el-table-column prop="Cube" label="体积(单个)"  width="120" align="right"></el-table-column>
            <el-table-column prop="Balance" label="库存"  width="100" align="right"></el-table-column>
            <el-table-column prop="_Status" label="有效"  width="80" align="center"></el-table-column>
            <!-- <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-col  :span="24">
            <el-pagination small
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="recordtotal">
            </el-pagination>
        </el-col>

        <el-dialog title="编辑" :visible.sync="editFormVisible" >
            <el-form :model="editForm">
                <el-form-item label="产品名称" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="商品条码" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Code" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="重量" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Weight" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item label="体积" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Cube" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label=" " :label-width="formLabelWidth">
                   <el-checkbox label="是否有效" v-model="editForm.Status"></el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="handleUpdate">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MaintainProductionJS from "./MaintainProduction.js";

    export default MaintainProductionJS;
</script>

<style >
    .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  
</style>





// WEBPACK FOOTER //
// src/components/MaintainProduction/MaintainProduction.vue